module.exports = __webpack_public_path__ + "img/mobile scanner stand13.86c9ad88.jpg";